import { render, staticRenderFns } from "./customsInfoInteractResDialog.vue?vue&type=template&id=2f9490d9&"
import script from "./customsInfoInteractResDialog.vue?vue&type=script&lang=js&"
export * from "./customsInfoInteractResDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f9490d9')) {
      api.createRecord('2f9490d9', component.options)
    } else {
      api.reload('2f9490d9', component.options)
    }
    module.hot.accept("./customsInfoInteractResDialog.vue?vue&type=template&id=2f9490d9&", function () {
      api.rerender('2f9490d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Cargo/Job/booking/tabs/ouJian/customsInfoInteractResDialog.vue"
export default component.exports